import { CurrencySymbolEnum } from '../../../lib/enums';
import TradePriceCache from '../../../lib/store-util/TradePriceCache';
import { formatCurrencyBySymbol } from '../../../lib/util/DataHelpers';

import SharedMobileSymbolDetailsHeader from '../../../shared_components/Header/components/MobileSymbolDetailsHeader/MobileSymbolDetailsHeader';

type Props = {
  symbol: string;
};

// Single market: the price cache is keyed by the plain symbol and prices are in dollars.
const MobileSymbolDetailsHeader = ({ symbol }: Props) => {
  const { calculatedSymbolPrices } = TradePriceCache.use(symbol, 'SymbolDetails/ChartHeader');
  const displayPrice = formatCurrencyBySymbol(
    calculatedSymbolPrices?.currentMainPrice,
    CurrencySymbolEnum.USD,
  );

  return <SharedMobileSymbolDetailsHeader displaySymbol={symbol} displayPrice={displayPrice} />;
};

export default MobileSymbolDetailsHeader;
